import * as React from "react"

import { cn } from "@/lib/utils"
import { CONTROL_CLASS, useFieldProps } from "./form-field"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  const fieldProps = useFieldProps(props)
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        CONTROL_CLASS,
        "py-1 file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
        className
      )}
      {...fieldProps}
    />
  )
}

export { Input }
